export default {
  data () {
    return {
      show: false,
      message: this.$globals.message
    }
  },
  watch: {
    '$globals.message' (newValue, oldValue) {
      this.message = this.$globals.message
      this.show = true

      setTimeout(() => {
        this.show = false
      }, 6000)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/notification/notification.js